import { Box } from '@mui/material';

export const featuredHeroArtworkSource =
  'https://images.unsplash.com/photo-1612287230202-1ff1d85d1bdf?q=80&w=250&auto=format&fit=crop';

export const featuredHeroPanelSx = Object.freeze({
  position: 'relative',
  overflow: 'hidden',

  display: 'flex',
  alignItems: 'center',
  minHeight: { xs: 'auto', lg: 446, xl: 468 },
  p: { xs: 2, sm: 2.5, md: 3 },

  // Continuous color across the entire card
  background: `
  radial-gradient(
    circle at 38% 16%,
    rgba(18, 163, 177, 0.28) 0%,
    rgba(18, 163, 177, 0.10) 34%,
    transparent 58%
  ),
  radial-gradient(
    circle at 88% 92%,
    rgba(8, 12, 20, 0.42) 0%,
    rgba(8, 12, 20, 0.16) 32%,
    transparent 58%
  ),
  linear-gradient(
    110deg,
    #102e35 0%,
    #16414a 38%,
    #29384f 70%,
    #2c2737 100%
  )
`,
});

export const featuredHeroContentSx = Object.freeze({
  position: 'relative',
  zIndex: 2,
  display: 'grid',
  width: '100%',
  gridTemplateColumns: {
    xs: 'minmax(0, 1fr)',
    lg: 'minmax(0, 0.92fr) minmax(0, 1.08fr)',
    xl: 'minmax(0, 1.1fr) minmax(0, 0.9fr)',
  },
  alignItems: 'stretch',
  gap: { xs: 3, lg: 2.5, xl: 3 },
});

export const featuredHeroActionsSx = Object.freeze({
  mt: { xs: 3, lg: 'auto' },
  pt: { lg: 2 },
});

export const featuredHeroArtworkSx = Object.freeze({
  position: 'absolute',
  inset: 0,
  zIndex: 0,
  overflow: 'hidden',
  pointerEvents: 'none',

  // Protect text readability without exposing black edges
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background:
      'linear-gradient(90deg, rgba(6, 18, 25, 0.28) 0%, rgba(6, 18, 25, 0.08) 48%, transparent 76%)',
    pointerEvents: 'none',
  },
});

export const featuredHeroImageSx = Object.freeze({
  position: 'absolute',
  inset: 0,

  width: '100%',
  height: '100%',

  display: 'block',
  objectFit: 'cover',

  // Adjust this percentage to move the controller artwork
  objectPosition: {
    xs: '62% center',
    sm: '59% center',
    md: '56% center',
    lg: '54% center',
  },

  opacity: {
    xs: 0.25,
    sm: 0.3,
    md: 0.34,
  },

  mixBlendMode: 'screen',

  filter:
    'brightness(1.04) contrast(1.08) saturate(1.12) drop-shadow(0 0 18px rgba(62, 166, 255, 0.12))',

  // Small zoom prevents uncovered edges
  transform: 'scale(1.04)',
  transformOrigin: 'center',

  userSelect: 'none',
  pointerEvents: 'none',
});

const FeaturedHeroArtwork = () => (
  <Box
    aria-hidden="true"
    data-artwork="featured-hero"
    data-testid="featured-hero-artwork"
    sx={featuredHeroArtworkSx}
  >
    <Box
      component="img"
      src={featuredHeroArtworkSource}
      alt=""
      draggable={false}
      data-testid="featured-hero-art-image"
      sx={featuredHeroImageSx}
    />
  </Box>
);

export default FeaturedHeroArtwork;
